import api from './api/api';

class Fail2banService {
    getBans() {
        return api.get('/admin/fail2ban/bans');
    }

    unbanIP(ip, endpoint = null) {
        const url = endpoint 
            ? `/admin/fail2ban/bans/${ip}?endpoint=${endpoint}`
            : `/admin/fail2ban/bans/${ip}`;
        return api.delete(url);
    }

    getStats() {
        return api.get('/admin/fail2ban/stats');
    }

    getWhitelist() {
        return api.get('/admin/fail2ban/whitelist');
    }

    addToWhitelist(ipAddress, reason, expiresInHours = null) {
        return api.post('/admin/fail2ban/whitelist', {
            ip_address: ipAddress,
            reason: reason,
            expires_in_hours: expiresInHours
        });
    }

    removeFromWhitelist(ipAddress) {
        return api.delete(`/admin/fail2ban/whitelist/${ipAddress}`);
    }
}

export default new Fail2banService();